import { apiGet, apiPost, apiPatch, apiDelete } from './client';
import type { Customer } from '../types';

export async function getCustomers(): Promise<Customer[]> {
  return apiGet<Customer[]>('/customers');
}

export async function getCustomer(id: string): Promise<Customer> {
  return apiGet<Customer>(`/customers/${id}`);
}

export async function createCustomer(data: Partial<Customer>): Promise<Customer> {
  return apiPost<Customer>('/customers', data);
}

export async function updateCustomer(id: string, data: Partial<Customer>): Promise<Customer> {
  return apiPatch<Customer>(`/customers/${id}`, data);
}

export async function deleteCustomer(id: string): Promise<void> {
  return apiDelete<void>(`/customers/${id}`);
}

export async function getCustomerSgpSummary(id: string): Promise<Record<string, unknown>> {
  return apiGet<Record<string, unknown>>(`/customers/${id}/sgp-summary`);
}

export async function getCustomerSgpClient360(id: string): Promise<Record<string, unknown>> {
  return apiGet<Record<string, unknown>>(`/customers/${id}/sgp-client-360`);
}

export async function resetCustomerTelegramIdentity(id: string): Promise<Customer> {
  return apiPost<Customer>(`/customers/${id}/reset-telegram-identity`);
}
